import { useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import { REVIEWS } from "@/data/site";

export default function ReviewsCarousel() {
  const [i, setI] = useState(0);
  const next = useCallback(() => setI((p) => (p + 1) % REVIEWS.length), []);
  const prev = () => setI((p) => (p - 1 + REVIEWS.length) % REVIEWS.length);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next]);

  const r = REVIEWS[i];
  return (
    <div className="relative" data-testid="reviews-carousel">
      <div className="min-h-[240px] md:min-h-[200px]">
        <AnimatePresence mode="wait">
          <motion.blockquote
            key={i}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="mb-6 flex gap-1 text-wine">
              {Array.from({ length: r.stars }).map((_, k) => (
                <Star key={k} className="h-4 w-4 fill-current" />
              ))}
            </div>
            <p className="font-display text-2xl leading-snug md:text-4xl">“{r.text}”</p>
            <footer className="mt-6 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
              {r.name} — {r.area}
            </footer>
          </motion.blockquote>
        </AnimatePresence>
      </div>
      <div className="mt-8 flex items-center gap-3">
        <button data-testid="review-prev" onClick={prev} aria-label="Previous review" className="flex h-11 w-11 items-center justify-center border border-border transition-colors hover:bg-secondary">
          <ChevronLeft className="h-5 w-5" strokeWidth={1.5} />
        </button>
        <button data-testid="review-next" onClick={next} aria-label="Next review" className="flex h-11 w-11 items-center justify-center border border-border transition-colors hover:bg-secondary">
          <ChevronRight className="h-5 w-5" strokeWidth={1.5} />
        </button>
        <span className="ml-3 font-mono text-xs text-muted-foreground">
          {String(i + 1).padStart(2, "0")} / {String(REVIEWS.length).padStart(2, "0")}
        </span>
      </div>
    </div>
  );
}
